import Swal from "sweetalert2"
import { toast } from "react-toastify"
import { IVivierModel } from "@common-models/*"
import { CONST_API_RECRUITMENT_VIVIERS_POST_ARCHIVE_ENDPOINT, CONST_API_RECRUITMENT_VIVIERS_POST_RESTORE_ENDPOINT } from "../../../endpoints"
import axios from "axios"

const useVivier = () => {
     function archive(viviers: IVivierModel[], onConfirmCallback?: () => void, onSuccessCallback?: () => void, onDismissCallback?: () => void, onErrorCallback?: () => void) {
          const ids = viviers.map(item => item.id)

          Swal.fire({
               icon: "warning",
               title: `Veuillez confirmer votre action`,
               text: `À savoir: les candidats contenus dans ${viviers.length > 1 ? "ces viviers" : "ce vivier"} seront toujours disponibles`,
               showCancelButton: true,
               confirmButtonText: "Confirmer",
               cancelButtonText: "Annuler",
               focusConfirm: true,
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    if (onConfirmCallback) onConfirmCallback()

                    return axios
                         .post(CONST_API_RECRUITMENT_VIVIERS_POST_ARCHIVE_ENDPOINT, { ids })
                         .then(() => {
                              if (onSuccessCallback) onSuccessCallback()
                              toast.success(viviers.length > 1 ? "Les viviers ont bien été archivés" : "Le vivier a bien été archivé", { autoClose: false })
                         })
                         .catch((e: any) => {
                              if (onErrorCallback) onErrorCallback()
                              toast.error(e?.response?.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !Swal.isLoading(),
          }).then(result => {
               if (result.isDismissed && onDismissCallback) onDismissCallback()
          })
     }

     function restore(viviers: IVivierModel[], onConfirmCallback?: () => void, onSuccessCallback?: () => void, onDismissCallback?: () => void, onErrorCallback?: () => void) {
          const ids = viviers.map(item => item.id)

          Swal.fire({
               icon: "warning",
               title: `Veuillez confirmer votre action`,
               showCancelButton: true,
               confirmButtonText: "Confirmer",
               cancelButtonText: "Annuler",
               focusConfirm: true,
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    if (onConfirmCallback) onConfirmCallback()

                    return axios
                         .post(CONST_API_RECRUITMENT_VIVIERS_POST_RESTORE_ENDPOINT, { ids })
                         .then(() => {
                              if (onSuccessCallback) onSuccessCallback()
                              toast.success(viviers.length > 1 ? "Les viviers ont bien été restaurés" : "Le vivier a bien été restauré", { autoClose: false })
                         })
                         .catch((e: any) => {
                              if (onErrorCallback) onErrorCallback()
                              toast.error(e?.response?.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !Swal.isLoading(),
          }).then(result => {
               if (result.isDismissed && onDismissCallback) onDismissCallback()
          })
     }

     return { archive, restore }
}

export default useVivier
